import { render, staticRenderFns } from "./PhotoAndText.vue?vue&type=template&id=67a3c47b&scoped=true&"
import script from "./PhotoAndText.vue?vue&type=script&lang=js&"
export * from "./PhotoAndText.vue?vue&type=script&lang=js&"
import style0 from "./PhotoAndText.vue?vue&type=style&index=0&id=67a3c47b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67a3c47b",
  null
  
)

export default component.exports